export const openInNewTab = () => {
  window.open("https://drive.google.com/file/d/1MhpwGKYQUsgO1SeFoUaxOpGW6pj7L5mE/view?usp=share_link", "_blank").focus();
};
